module.exports = __webpack_public_path__ + "img/tpc-42.77c7dc37.webp";